// extracted by mini-css-extract-plugin
export default {"defaultKindRadius":"aNHLV","containerKindRadius":"bNHLV","cardKindRadius":"cNHLV","iconKindRadius":"dNHLV","responsive":"eNHLV"};